<template>
    <div :class="containerClass" @click="onWrapperClick">
        <AppCommonTopbar @menu-toggle="onMenuToggle"/>

        <div class="layout-main-container">
            <div class="layout-main">
                <div class="text-center" v-if="!checkProdUrl">
                    <p style="font-weight: bold; color: red;">Тестове середовище для розробки, продуктове за <a href="https://services.vector-vs.com/">посиланням</a></p>
                </div>
                <slot/>
            </div>
        </div>

    </div>
</template>

<script>
import AppMenu from '../Components/AppMenu.vue';
import AppFooter from '../Components/AppFooter.vue';
import Toast from 'primevue/toast';
import AppCommonTopbar from "@/Components/AppCommonTopbar";

export default {
    data() {
        return {
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: true,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu: [
                {
                    label: 'Навигация',
                    items: [
                        // {label: 'Главная', icon: 'pi pi-fw pi-home', to: this.route('dashboard'), prefix: 'dashboard', allowedRoles: []},
                        {label: 'Пользователи', icon: 'pi pi-fw pi-user', to: this.route('users.index'),allowedRoles: ['admin']},
                        {label: 'Загрузка БД', icon: 'pi pi-fw pi-upload', to: this.route('upload'),allowedRoles: ['admin']},
                        {label: 'Калькулятор', icon: 'pi pi-fw pi-table', to: this.route('cross-reference'),allowedRoles: []},
                        {label: 'Конфигуратор КРМ', icon: 'pi pi-fw pi-table', to: this.route('krm'),allowedRoles: []},
                        {
                            label: 'Выйти', icon: 'pi pi-fw pi-sign-out', command: () => {
                                this.$inertia.post(this.route('logout'))
                            },
                        }]
                },
            ]
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    methods: {
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }

                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                } else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            } else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
        onLayoutChange(layoutMode) {
            this.layoutMode = layoutMode;
        },
        onLayoutColorChange(layoutColorMode) {
            this.layoutColorMode = layoutColorMode;
        },
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                'p-ripple-disabled': this.$primevue.config.ripple === false,
            }];
        },
        logo() {
            return (this.layoutColorMode === 'dark') ? "images/logo-white.svg" : "images/logo.svg";
        },
        checkProdUrl() {
            return window.location.hostname === 'services.vector-vs.com'
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        AppCommonTopbar,
        'AppMenu': AppMenu,
        'AppFooter': AppFooter,
        Toast,
    }
}
</script>
